// 1:未开通所查询的视频彩铃功能。
// 2：已开通所查询的视频彩铃功能，但所对应视频彩铃播放能力处于关闭状态。
// 3：已开通所查询的视频彩铃功能，且所对应的视频彩铃播放能力处于开启状态
export var VrbtStatusDic;
(function (VrbtStatusDic) {
    VrbtStatusDic["None"] = "1";
    VrbtStatusDic["Close"] = "2";
    VrbtStatusDic["Open"] = "3";
})(VrbtStatusDic || (VrbtStatusDic = {}));
export const VrbtStatusType = {
    None: VrbtStatusDic.None,
    Close: VrbtStatusDic.Close,
    Open: VrbtStatusDic.Open
};
